import { useCallback } from 'react'
import { useTrackRemoveAttachment } from '../../../../hooks/attachments-hooks'
import { useAttachmentStore } from '../../../../store'
import type { AttachmentPillProps } from '../types'

/**
 * Removes by list position, and returns undefined where the list offers no
 * removal, so a pill can pass the result straight to `onRemove` and let
 * `AttachmentStub` decide the chrome. Insights detach as a set and can't use this.
 */
export function useRemoveAttachment(attachment: AttachmentPillProps): (() => void) | undefined {
  const { removeAttachment } = useAttachmentStore()
  const trackRemoveAttachment = useTrackRemoveAttachment()

  const type = attachment.pending?.type ?? attachment.attachment?.type

  const remove = useCallback(() => {
    removeAttachment(attachment.index)
    trackRemoveAttachment({ type, trigger: 'Attachment Pill' })
  }, [attachment.index, removeAttachment, trackRemoveAttachment, type])

  return attachment.canRemove ? remove : undefined
}
